'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
react.Drawer.displayName = 'Drawer';
Object.defineProperty(exports, 'Drawer', {
  enumerable: true,
  get: function () {
    return react.Drawer;
  }
});